module.exports = __webpack_public_path__ + "img/redResume.869de440.svg";